module.exports = __webpack_public_path__ + "img/anagraph_dark.430a1cf4.png";